module.exports = __webpack_public_path__ + "img/Group5126.d4aad40d.png";